/* global axios */
import ApiClient from './ApiClient';

class EngageApi extends ApiClient {
  constructor() {
    super('engage', { accountScoped: true });
  }

  getTraffic(params = {}) {
    return axios.get(`${this.url}/traffic`, { params });
  }
}

export default new EngageApi();
